interface HasId {
  _id: string;
}

interface HasDeleted {
  deleted: boolean;
}

type Deletable = HasId & HasDeleted;

export function updateDeletedInList<T extends Deletable>(
  items: T[],
  itemId: string,
  deleted: boolean
): T[] {
  return items.map((item) =>
    item._id === itemId ? { ...item, deleted } : item
  );
}

export function updateDeletedInSingleItem<T extends Deletable | undefined>(
  item: T,
  itemId: string,
  deleted: boolean
): T {
  if (!item || item._id !== itemId) {
    return item;
  }
  return { ...item, deleted } as T;
}
